// import React, { useEffect, useState ,useMemo} from "react";
// import {
//   Box,
//   Typography,
//   CircularProgress,
//   Fade,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   useMediaQuery,
//   useTheme,
//   AppBar,
//   Toolbar,
//   Container
// } from "@mui/material";
// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';
// import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import { Users, UserCheck, Clock, TrendingUp } from "lucide-react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import CompanyDashboard from './companyDashboad/index';
// import { KpiCard } from "../../components/Charts/KpiCard";
// import { DivisionBreakdown } from "../../components/Charts/DivisionBreakdown";
// import { TraineesDivisionBreakdown } from "../../components/Charts/TraineesDivisionBreakdown";
// import { TraineesOverview } from "../../components/Charts/TraineesOverview";
// import WeeklyAttendanceTrend from "../../components/Charts/WeeklyAttendanceTrend";
// import { EmployeeTypeChart } from "../../components/Charts/EmployeeTypeChart";
// import { DGESatt } from "../../components/Charts/DTSLocAtt";
// import QuickAccessSection from "../../components/Cards/QuickAccessSection"; 

// import {
//   GetAllAttendance,
//   GetLoadBaAttendance  // This action fetches CDPLC attendance data
// } from "../../action/Attendance";
// import { EmployeeStrengthAttendanceChart } from "../../components/Charts/EmployeeStrengthAttendanceChart";
// import { Person } from "@material-ui/icons";

// // ─── KPI Card Skeleton ────────────────────────────────────────────────────────
// const KpiCardSkeleton = () => (
//   <Box
//     sx={{
//       position: "relative",
//       background: "linear-gradient(135deg, #EBF0FA 0%, #dce8f7 100%)",
//       borderRadius: "20px",
//       padding: "24px",
//       overflow: "hidden",
//       border: "1px solid rgba(255,255,255,0.8)",
//       boxShadow: "0 4px 24px rgba(30,58,110,0.06)",
//       "@keyframes shimmer": {
//         "0%": { backgroundPosition: "-200% 0" },
//         "100%": { backgroundPosition: "200% 0" },
//       },
//       "&::after": {
//         content: '""',
//         position: "absolute",
//         inset: 0,
//         background:
//           "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%)",
//         backgroundSize: "200% 100%",
//         animation: "shimmer 1.8s infinite",
//         borderRadius: "20px",
//       },
//     }}
//   >
//     <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2.5 }}>
//       <Box
//         sx={{
//           width: "45%",
//           height: 13,
//           backgroundColor: "rgba(30,58,110,0.12)",
//           borderRadius: "6px",
//         }}
//       />
//       <Box
//         sx={{
//           width: 38,
//           height: 38,
//           backgroundColor: "rgba(30,58,110,0.1)",
//           borderRadius: "10px",
//         }}
//       />
//     </Box>
//     <Box
//       sx={{
//         width: "55%",
//         height: 34,
//         backgroundColor: "rgba(30,58,110,0.14)",
//         borderRadius: "8px",
//         mb: 1.5,
//       }}
//     />
//     <Box
//       sx={{
//         width: "35%",
//         height: 11,
//         backgroundColor: "rgba(30,58,110,0.08)",
//         borderRadius: "6px",
//       }}
//     />
//   </Box>
// );

// // ─── Chart Skeleton ───────────────────────────────────────────────────────────
// const ChartSkeleton = ({ height = 300 }) => (
//   <Box
//     sx={{
//       position: "relative",
//       background: "linear-gradient(135deg, #F4F6FA 0%, #EBF0FA 100%)",
//       borderRadius: "20px",
//       padding: "24px",
//       height: height,
//       overflow: "hidden",
//       border: "1px solid rgba(30,58,110,0.06)",
//       boxShadow: "0 4px 24px rgba(30,58,110,0.05)",
//       "@keyframes shimmer2": {
//         "0%": { backgroundPosition: "-200% 0" },
//         "100%": { backgroundPosition: "200% 0" },
//       },
//       "&::after": {
//         content: '""',
//         position: "absolute",
//         inset: 0,
//         background:
//           "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.7) 50%, transparent 100%)",
//         backgroundSize: "200% 100%",
//         animation: "shimmer2 1.8s infinite",
//         borderRadius: "20px",
//       },
//     }}
//   >
//     <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
//       <Box
//         sx={{
//           width: "28%",
//           height: 20,
//           backgroundColor: "rgba(30,58,110,0.1)",
//           borderRadius: "6px",
//         }}
//       />
//       <Box
//         sx={{
//           width: "16%",
//           height: 20,
//           backgroundColor: "rgba(30,58,110,0.07)",
//           borderRadius: "6px",
//         }}
//       />
//     </Box>
//     <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1.5, height: "70%" }}>
//       {[65, 80, 50, 90, 70, 85, 60].map((h, i) => (
//         <Box
//           key={i}
//           sx={{
//             flex: 1,
//             height: `${h}%`,
//             backgroundColor: "rgba(30,58,110,0.08)",
//             borderRadius: "6px 6px 0 0",
//           }}
//         />
//       ))}
//     </Box>
//   </Box>
// );

// // ─── Navigation Drawer Component ───────────────────────────────────────────────
// const NavigationDrawer = ({ open, onClose, activeTab, onTabChange }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const overviewItems = [
//     {
//       id: 4,
//       label: 'Company',
//       icon: <DashboardIcon />,
//       color: '#ef4444',
//       disabled: true ,
//       isBold: true,
//     },
//     {
//       id: 5,
//       label: 'Own',
//       icon: <Person />,
//       color: '#f59e0b',
//       isBold: true,
//       disabled: true
//     },
//   ];

//   const mainItems = [
//     {
//       id: 0,
//       label: 'HR Dashboard',
//       icon: <PeopleAltIcon />,
//       color: '#330066',
//       description: 'Employee attendance and performance metrics'
//     },
//     {
//       id: 1,
//       label: 'Financial Dashboard',
//       icon: <AccountBalanceIcon />,
//       color: '#10b981',
//       description: 'Budget tracking and fiscal overview',
//       disabled: true
//     },
//     {
//       id: 2,
//       label: 'Sales Performance',
//       icon: <TrendingUp />,
//       color: '#f59e0b',
//       description: 'Sales metrics and targets',
//       disabled: true
//     },
//     {
//       id: 3,
//       label: 'Customer Support',
//       icon: <Users />,
//       color: '#8b5cf6',
//       description: 'Support ticket analytics',
//       disabled: true
//     },
//   ];

//   const otherKpisItems = [
//     {
//       id: 7,
//       label: 'Operational KPIs',
//       icon: <Clock />,
//       color: '#06b6d4',
//       description: 'Operational efficiency metrics',
//       disabled: true
//     },
//     {
//       id: 8,
//       label: 'Quality Metrics',
//       icon: <UserCheck />,
//       color: '#8b5cf6',
//       description: 'Quality assurance indicators',
//       disabled: true
//     },
//     {
//       id: 9,
//       label: 'Project Status',
//       icon: <TrendingUp />,
//       color: '#f43f5e',
//       description: 'Project completion rates',
//       disabled: true
//     },
//   ];

//   const handleTabClick = (tabId) => {
//     onTabChange(tabId);
//     onClose();
//   };

//   const renderMenuItems = (items, showDivider = false) => (
//     <>
//       <List sx={{ p: 0 }}>
//         {items.map((item) => (
//           <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
//             <ListItemButton
//               onClick={() => handleTabClick(item.id)}
//               disabled={item.disabled}
//               selected={activeTab === item.id}
//               sx={{
//                 borderRadius: '12px',
//                 py: 1.5,
//                 px: 2,
//                 transition: 'all 0.2s ease',
//                 ...(item.isBold && {
//                   borderLeft: '4px solid',
//                   borderLeftColor: item.color,
//                   backgroundColor: 'rgba(239,68,68,0.04)',
//                 }),
//                 '&.Mui-selected': {
//                   backgroundColor: `${item.color}12`,
//                   '&:hover': {
//                     backgroundColor: `${item.color}20`,
//                   },
//                   '& .MuiListItemIcon-root': {
//                     color: item.color,
//                   },
//                   '& .MuiListItemText-primary': {
//                     color: item.color,
//                     fontWeight: 600,
//                   },
//                 },
//                 '&:hover': {
//                   backgroundColor: 'rgba(30,58,110,0.04)',
//                   transform: 'translateX(4px)',
//                 },
//                 '&.Mui-disabled': {
//                   opacity: 0.5,
//                   cursor: 'not-allowed',
//                 },
//               }}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: 40,
//                   color: activeTab === item.id ? item.color : '#64748b',
//                   transition: 'color 0.2s ease',
//                 }}
//               >
//                 {item.icon}
//               </ListItemIcon>
//               <ListItemText
//                 primary={item.label}
//                 secondary={item.description}
//                 primaryTypographyProps={{
//                   fontSize: '0.95rem',
//                   fontWeight: item.isBold ? 700 : (activeTab === item.id ? 600 : 500),
//                   ...(item.isBold && {
//                     color: item.color,
//                   }),
//                 }}
//                 secondaryTypographyProps={{
//                   fontSize: '0.75rem',
//                   sx: { color: 'text.secondary', mt: 0.5 }
//                 }}
//               />
//               {item.disabled && (
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     bgcolor: 'rgba(0,0,0,0.04)',
//                     px: 1,
//                     py: 0.5,
//                     borderRadius: '4px',
//                     color: 'text.secondary',
//                     fontSize: '0.7rem'
//                   }}
//                 >
//                   Coming Soon
//                 </Typography>
//               )}
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//       {showDivider && (
//         <Divider sx={{ my: 2, borderColor: 'rgba(30,58,110,0.08)' }} />
//       )}
//     </>
//   );

//   return (
//     <Drawer
//       anchor="left"
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           width: isMobile ? '85%' : 320,
//           maxWidth: 320,
//           borderTopRightRadius: 20,
//           borderBottomRightRadius: 20,
//           background: 'linear-gradient(135deg, #ffffff 0%, #fafcff 100%)',
//           boxShadow: '8px 0 32px rgba(30,58,110,0.12)',
//         }
//       }}
//     >
//       <Box sx={{ p: 3 }}>
//         <Box sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           mb: 3
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box
//               sx={{
//                 width: 32,
//                 height: 32,
//                 borderRadius: '10px',
//                 background: 'linear-gradient(135deg, #330066 0%, #4A6FA5 100%)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
//               <DashboardIcon sx={{ color: 'white', fontSize: 18 }} />
//             </Box>
//             <Typography
//               sx={{
//                 fontSize: '1.2rem',
//                 fontWeight: 700,
//                 background: 'linear-gradient(135deg, #330066 0%, #4A6FA5 100%)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Dashboards
//             </Typography>
//           </Box>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <Divider sx={{ mb: 2, borderColor: 'rgba(30,58,110,0.08)' }} />

//         <Typography
//           variant="subtitle2"
//           sx={{
//             px: 2,
//             mb: 1,
//             color: '#ef4444',
//             fontWeight: 700,
//             fontSize: '0.85rem',
//             textTransform: 'uppercase',
//             letterSpacing: '0.5px'
//           }}
//         >
//           OVERVIEW
//         </Typography>
//         {renderMenuItems(overviewItems, true)}

//         <Typography
//           variant="subtitle2"
//           sx={{
//             px: 2,
//             mb: 1,
//             color: '#330066',
//             fontWeight: 600,
//             fontSize: '0.85rem',
//             textTransform: 'uppercase',
//             letterSpacing: '0.5px'
//           }}
//         >
//           KPI'S 
//         </Typography>
//         {renderMenuItems(mainItems, false)}

//         <Divider sx={{ my: 2, borderColor: 'rgba(30,58,110,0.12)', borderBottomWidth: 2 }} />

//         <Typography
//           variant="subtitle2"
//           sx={{
//             px: 2,
//             mb: 1,
//             color: '#f43f5e',
//             fontWeight: 600,
//             fontSize: '0.85rem',
//             textTransform: 'uppercase',
//             letterSpacing: '0.5px'
//           }}
//         >
//           OTHER KPIs
//         </Typography>
//         {renderMenuItems(otherKpisItems, false)}
//       </Box>
//     </Drawer>
//   );
// };

// // ─── Main Dashboard ─────────────────────────────────────────────────────────── 
// const Dashboard = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const [selectedYear, setSelectedYear] = useState(() => { 
//     return new Date().getFullYear().toString();
//   });

//   const {
//     divisionData,
//     traineeTypes,
//     traineeDivision,
//     allAttendance,
//     loading,
//     weeklyAttendance,
//     loadBaAttendance, // Add this to get CDPLC attendance data from Redux state
//   } = useSelector((state) => state.attendanceCard);

//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);
//   const [cachedAllAttendance, setCachedAllAttendance] = useState(null);
//   const [cachedTraineeTypes, setCachedTraineeTypes] = useState(null);
//   const [cachedLoadBaAttendance, setCachedLoadBaAttendance] = useState(null); // Add cache for CDPLC data
//   const [dataLoaded, setDataLoaded] = useState(false);

//   const [loadingStates, setLoadingStates] = useState({
//     divisionData: true,
//     traineeTypes: true,
//     traineeDivision: true,
//     allAttendance: true,
//     weeklyAttendance: true,
//     loadBaAttendance: true, // Add loading state for CDPLC data
//   });

//   const today = new Date().toISOString().split("T")[0];

//   const handleTabChange = (tabId) => {
//     setActiveTab(tabId);
//   };

//   const toggleDrawer = () => {
//     setDrawerOpen(!drawerOpen);
//   };

//   useEffect(() => {
//     const cachedTrainee = localStorage.getItem("dashboard_traineeTypes");
//     const cachedLoadBa = localStorage.getItem("dashboard_loadBaAttendance");

//     if (cachedTrainee) {
//       setCachedTraineeTypes(JSON.parse(cachedTrainee));
//       setLoadingStates((prev) => ({ ...prev, traineeTypes: false }));
//     }

//     if (cachedLoadBa) {
//       setCachedLoadBaAttendance(JSON.parse(cachedLoadBa));
//       setLoadingStates((prev) => ({ ...prev, loadBaAttendance: false }));
//     }

//     setDataLoaded(true);
//   }, []);

//   useEffect(() => {
//     if (divisionData && divisionData.length > 0)
//       setLoadingStates((prev) => ({ ...prev, divisionData: false }));
//   }, [divisionData]);

//   useEffect(() => {
//     if (traineeTypes && traineeTypes.length > 0) {
//       setLoadingStates((prev) => ({ ...prev, traineeTypes: false }));
//       localStorage.setItem("dashboard_traineeTypes", JSON.stringify(traineeTypes));
//     }
//   }, [traineeTypes]);

//   useEffect(() => {
//     if (traineeDivision && traineeDivision.length > 0)
//       setLoadingStates((prev) => ({ ...prev, traineeDivision: false }));
//   }, [traineeDivision]);

//   useEffect(() => {
//     if (allAttendance && allAttendance.length > 0) {
//       setLoadingStates((prev) => ({ ...prev, allAttendance: false }));
//       localStorage.setItem("dashboard_allAttendance", JSON.stringify(allAttendance));
//     }
//   }, [allAttendance]);

//   useEffect(() => {
//     if (weeklyAttendance && weeklyAttendance.length > 0)
//       setLoadingStates((prev) => ({ ...prev, weeklyAttendance: false }));
//   }, [weeklyAttendance]);

//   // Add effect for CDPLC attendance data
//   useEffect(() => {
//     if (loadBaAttendance && loadBaAttendance.length > 0) {
//       setLoadingStates((prev) => ({ ...prev, loadBaAttendance: false }));
//       localStorage.setItem("dashboard_loadBaAttendance", JSON.stringify(loadBaAttendance));
//     }
//   }, [loadBaAttendance]);

//   useEffect(() => {
//     const metaThemeColor = document.querySelector('meta[name="theme-color"]');
//     if (metaThemeColor) metaThemeColor.setAttribute("content", "#330066");

//     const fetchData = async () => {
//       try {
//         if (!cachedAllAttendance) dispatch(GetAllAttendance(today, today));
//         // Fetch CDPLC attendance data
//         dispatch(GetLoadBaAttendance());  
//       } catch (error) {
//         console.error("Error dispatching actions:", error);
//       }
//     };

//     fetchData();
//   }, [dispatch, cachedAllAttendance, cachedTraineeTypes, today]);

//   // ── Transforms ──
//   const transformedDivisionData =
//     divisionData?.map((item) => ({
//       division: item.HLD_DIV_CODE || item.HLD_DIV_CODE || "Unknown",
//       rate: parseFloat(item.PERCENTAGE_EXECUTIVE) || 0,
//       categories: {
//         executive: {
//           st: parseInt(item.STRENGTH_EXECUTIVE) || 0,
//           at: parseInt(item.ATTENDANCE_EXECUTIVE) || 0,
//           percent: parseFloat(item.PERCENTAGE_EXECUTIVE) || 0,
//         },
//         supervisory: {
//           st: parseInt(item.STRENGTH_SUPERVISORY) || 0,
//           at: parseInt(item.ATTENDANCE_SUPERVISORY) || 0,
//           percent: parseFloat(item.PERCENTAGE_SUPERVISORY) || 0,
//         },
//         clerical: item.STRENGTH_CLERICAL
//           ? { st: parseInt(item.STRENGTH_CLERICAL) || 0, at: 0, percent: 0 }
//           : null,
//       },
//     })) || [];

//   const transformedTraineeByDivision =
//     traineeDivision
//       ?.map((item) => ({
//         division: item.V_DIVNAME || item.HLD_DIV_CODE || "Unknown",
//         clerical_strength: parseInt(item.STRENGTH_CLERICAL) || 0,
//         clerical_attendance: parseInt(item.ATTENDANCE_CLERICAL) || 0,
//         industrial_strength: parseInt(item.STRENGTH_INDUSTRIAL) || 0,
//         industrial_attendance: parseInt(item.ATTENDANCE_INDUSTRIAL) || 0,
//         total_strength:
//           (parseInt(item.STRENGTH_CLERICAL) || 0) +
//           (parseInt(item.STRENGTH_INDUSTRIAL) || 0),
//         total_attendance:
//           (parseInt(item.ATTENDANCE_CLERICAL) || 0) +
//           (parseInt(item.ATTENDANCE_INDUSTRIAL) || 0),
//         total_percent: 0,
//       }))
//       .map((item) => ({
//         ...item,
//         total_percent:
//           item.total_strength > 0
//             ? Math.round((item.total_attendance / item.total_strength) * 100)
//             : 0,
//       })) || [];

//   const employeeTypeData = cachedTraineeTypes || traineeTypes || [];

//   const totalEmployees =
//     divisionData?.reduce(
//       (sum, item) =>
//         sum +
//         (parseInt(item.STRENGTH_EXECUTIVE) || 0) +
//         (parseInt(item.STRENGTH_SUPERVISORY) || 0),
//       0
//     ) || 0;

//   const totalAttendance =
//     divisionData?.reduce(
//       (sum, item) =>
//         sum +
//         (parseInt(item.ATTENDANCE_EXECUTIVE) || 0) +
//         (parseInt(item.ATTENDANCE_SUPERVISORY) || 0),
//       0
//     ) || 0;

//   const attendanceRate =
//     totalEmployees > 0 ? Math.round((totalAttendance / totalEmployees) * 100) : 0;

//   const totalAttendanceItem = (allAttendance || []).find((item) => {
//     const typeValue =
//       item?.Type || item?.TYPE || item?.EmployeeType || item?.employeeType;
//     return typeof typeValue === "string" && typeValue.toUpperCase() === "TOTAL";
//   });

//   const kpiActualStrength =
//     parseInt(totalAttendanceItem?.ActualStrength) || totalEmployees || 0;
//   const kpiAttendance =
//     parseInt(totalAttendanceItem?.Attendance) || totalAttendance || 0;

//   const kpiEligibleStrength =
//     parseInt(totalAttendanceItem?.EligibleStrength) || 0;

//   const kpiAttendanceRate = kpiActualStrength > 0
//     ? Math.round((kpiAttendance / kpiActualStrength) * 100)
//     : 0;

//   const apiWeek = weeklyAttendance || [];
//   const attendanceFromApi = apiWeek.map((item) => ({
//     v: parseInt(item.Attendance) || 0,
//     dayName: item.DayName || "",
//   }));
//   const eligibleFromApi = apiWeek.map((item) => ({
//     v: parseInt(item.Eligible) || 0,
//     dayName: item.DayName || "",
//   }));
//   const rateForChart = attendanceFromApi.map((a, i) => {
//     const el = eligibleFromApi[i]?.v || 0;
//     return {
//       v: el ? Math.max(0, Math.min(100, Math.round((a.v / el) * 100))) : 0,
//       dayName: a.dayName,
//     };
//   });

//   // Transform CDPLC attendance data for the component
//   // Assuming loadBaAttendance contains data with fields like:
//   // - CDPLC_Code or division
//   // - Strength
//   // - Attendance
// // In your Dashboard component, update the transformedCDPLCData:
// const transformedCDPLCData = useMemo(() => {
//   // Use loadBaAttendance directly from Redux (it's already an array)
//   const data = loadBaAttendance || [];
//   console.log('CDPLC Data received in Dashboard:', data);
//   console.log('Data length:', data.length);

//   // Log the first item to see the structure
//   if (data.length > 0) {
//     console.log('First CDPLC item:', data[0]);
//   }

//   return data;
// }, [loadBaAttendance]);

// // Also update the loading state effect
// useEffect(() => {
//   console.log('loadBaAttendance changed:', loadBaAttendance);
//   if (loadBaAttendance && loadBaAttendance.length > 0) {
//     console.log('CDPLC Data loaded successfully:', loadBaAttendance);
//     setLoadingStates(prev => ({ ...prev, loadBaAttendance: false }));
//     localStorage.setItem("dashboard_loadBaAttendance", JSON.stringify(loadBaAttendance));
//   } else if (loadBaAttendance && loadBaAttendance.length === 0) {
//     console.log('CDPLC Data is empty array');
//     setLoadingStates(prev => ({ ...prev, loadBaAttendance: false }));
//   }
// }, [loadBaAttendance]);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         height: "calc(100vh - 120px)", 
//         backgroundColor: "#F4F6FA",
//         padding: { xs: "20px 14px", sm: "28px 20px", md: "36px 28px" },
//         backgroundImage:
//           "radial-gradient(rgba(30,58,110,0.06) 1px, transparent 1px)",
//         backgroundSize: "28px 28px",
//         overflow: "hidden", 
//       }}
//     >
//       {/* Hamburger Menu Button and Header */}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           mb: 3,
//           flexShrink: 0,  
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//           <IconButton
//             onClick={toggleDrawer}
//             sx={{
//               backgroundColor: '#ffffff',
//               boxShadow: '0 2px 8px rgba(30,58,110,0.12)',
//               borderRadius: '12px',
//               padding: '10px',
//               '&:hover': {
//                 backgroundColor: '#f5f5f5',
//                 transform: 'scale(1.05)',
//               },
//               transition: 'all 0.2s ease',
//             }}
//           >
//             <MenuIcon sx={{ color: '#330066' }} />
//           </IconButton>

//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: 700,
//               background: 'linear-gradient(135deg, #330066 0%, #4A6FA5 100%)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               fontSize: { xs: '1.2rem', sm: '1.5rem' },
//             }}
//           >
//             {activeTab === 0 ? 'HR Dashboard' :
//               activeTab === 1 ? 'Financial Dashboard' :
//                 activeTab === 4 ? 'Company Overview' :
//                   activeTab === 5 ? 'Own Overview' :
//                     'Dashboard'}
//           </Typography>
//         </Box>

//         <Typography
//           variant="body2"
//           sx={{
//             color: '#64748b',
//             backgroundColor: '#ffffff',
//             padding: '6px 12px',
//             borderRadius: '20px',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
//             display: { xs: 'none', sm: 'block' }
//           }}
//         >
//           {new Date().toLocaleDateString('en-US', {
//             weekday: 'long',
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           })}
//         </Typography>
//       </Box>

//       {/* Navigation Drawer */}
//       <NavigationDrawer
//         open={drawerOpen}
//         onClose={() => setDrawerOpen(false)}
//         activeTab={activeTab}
//         onTabChange={handleTabChange}
//       />

//       {/* Scrollable Content Area */}
//       <Box
//         sx={{
//           flex: 1,
//           overflowY: 'auto',
//           overflowX: 'hidden',
//           pr: { xs: 0, sm: 1 },  
//           '&::-webkit-scrollbar': {
//             width: '0px',
//           },
//           '&::-webkit-scrollbar-track': {
//             background: '#f1f1f1',
//             borderRadius: '10px',
//           },
//           '&::-webkit-scrollbar-thumb': {
//             background: '#F4F6FA',
//             borderRadius: '10px',
//             '&:hover': {
//               background: '#a8a8a8',
//             },
//           },
//         }}
//       >
//         {/* ── HR Dashboard ── */}
//         {activeTab === 0 && (
//           <Fade in={true} timeout={600}>
//             <Box>
//               {/* ── Employee Strength vs Attendance ── */}
//               <Box sx={{ marginBottom: "24px" }}>
//                 {loadingStates.allAttendance ? (
//                   <ChartSkeleton height={350} />
//                 ) : (
//                   <EmployeeStrengthAttendanceChart
//                     allAttendance={cachedAllAttendance || allAttendance}
//                   />
//                 )}
//               </Box>

//               {/* ── CDPLC Breakdown - Using GetLoadBaAttendance data ── */}
//               <Box sx={{ marginBottom: "24px" }}>
//                 {loadingStates.loadBaAttendance ? (
//                   <ChartSkeleton height={300} />
//                 ) : (
//                   <DGESatt
//                     data={transformedCDPLCData}
//                     loading={loadingStates.loadBaAttendance}
//                   />
//                 )}
//               </Box>

//               {/* ── Division Breakdown ── */}
//               {/* <Box sx={{ marginBottom: "24px" }}>
//                 {loadingStates.divisionData ? (
//                   <ChartSkeleton height={400} />
//                 ) : (
//                   transformedDivisionData.length > 0 && (
//                     <DivisionBreakdown divisionData={transformedDivisionData} />
//                   )
//                 )}
//               </Box> */}

//               {/* <Box sx={{ marginBottom: "24px" }}>
//                 {loadingStates.traineeTypes ? (
//                   <ChartSkeleton height={300} />
//                 ) : (
//                   <EmployeeTypeChart employeeTypeData={employeeTypeData} />
//                 )}
//               </Box> */}

//               {/* <Box sx={{ marginBottom: "24px" }}>
//                 {loadingStates.traineeDivision ? (
//                   <ChartSkeleton height={400} />
//                 ) : (
//                   <TraineesDivisionBreakdown traineeDivisionData={traineeDivision} />
//                 )}
//               </Box> */}

//               <Box sx={{ height: '20px' }} />
//             </Box>
//           </Fade>
//         )}

//         {/* ── Financial Dashboard ── */}
//         {activeTab === 1 && (
//           <Fade in={true} timeout={500}>
//             <Box
//               sx={{
//                 background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
//                 color: "white",
//                 padding: "40px 36px",
//                 borderRadius: "20px",
//                 marginBottom: "32px",
//                 boxShadow: "0 8px 40px rgba(16,185,129,0.25)",
//               }}
//             >
//               <Typography
//                 variant="h4"
//                 sx={{ fontWeight: 700, marginBottom: "8px", fontSize: "28px" }}
//               >
//                 Financial Dashboard
//               </Typography>
//               <Typography sx={{ fontSize: "16px", opacity: 0.85, fontWeight: 400 }}>
//                 Financial metrics, budgets, and fiscal performance overview.
//               </Typography>
//               <Box sx={{ marginTop: "24px" }}>
//                 <Typography sx={{ fontSize: "14px", opacity: 0.75, fontStyle: "italic" }}>
//                   Financial dashboard content coming soon...
//                 </Typography>
//               </Box>
//             </Box>
//           </Fade>
//         )}

//         {activeTab === 4 && (
//           <Fade in={true} timeout={600}>
//             <Box>
//               <CompanyDashboard selectedYear="2026" />
//             </Box>
//           </Fade>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default Dashboard;
import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  Fade,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BadgeIcon from "@mui/icons-material/Badge";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import { Users, UserCheck, Clock, TrendingUp } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import CompanyDashboard from "./companyDashboad/index";
import { DGESatt } from "../../components/Charts/DTSLocAtt";
import { GetAllAttendance } from "../../action/Attendance";
import { EmployeeStrengthAttendanceChart } from "../../components/Charts/EmployeeStrengthAttendanceChart";
import EmployeeAttendanceChart from "../../components/Charts/EmployeeAttendanceChart";
import { Person } from "@material-ui/icons";
import AttendanceManagement from "../attendance_management/AttendanceManagement";
import Employees from "../attendance_management/Employees";
import Production from "../attendance_management/Production";

// ─── KPI Card Skeleton ────────────────────────────────────────────────────────
const KpiCardSkeleton = () => (
  <Box
    sx={{
      position: "relative",
      background: "linear-gradient(135deg, #EBF0FA 0%, #dce8f7 100%)",
      borderRadius: "20px",
      padding: "24px",
      overflow: "hidden",
      border: "1px solid rgba(255,255,255,0.8)",
      boxShadow: "0 4px 24px rgba(30,58,110,0.06)",
      "@keyframes shimmer": {
        "0%": { backgroundPosition: "-200% 0" },
        "100%": { backgroundPosition: "200% 0" },
      },
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.8s infinite",
        borderRadius: "20px",
      },
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2.5 }}>
      <Box sx={{ width: "45%", height: 13, backgroundColor: "rgba(30,58,110,0.12)", borderRadius: "6px" }} />
      <Box sx={{ width: 38, height: 38, backgroundColor: "rgba(30,58,110,0.1)", borderRadius: "10px" }} />
    </Box>
    <Box sx={{ width: "55%", height: 34, backgroundColor: "rgba(30,58,110,0.14)", borderRadius: "8px", mb: 1.5 }} />
    <Box sx={{ width: "35%", height: 11, backgroundColor: "rgba(30,58,110,0.08)", borderRadius: "6px" }} />
  </Box>
);

// ─── Chart Skeleton ───────────────────────────────────────────────────────────
const ChartSkeleton = ({ height = 300 }) => (
  <Box
    sx={{
      position: "relative",
      background: "linear-gradient(135deg, #F4F6FA 0%, #EBF0FA 100%)",
      borderRadius: "20px",
      padding: "24px",
      height: height,
      overflow: "hidden",
      border: "1px solid rgba(30,58,110,0.06)",
      boxShadow: "0 4px 24px rgba(30,58,110,0.05)",
      "@keyframes shimmer2": {
        "0%": { backgroundPosition: "-200% 0" },
        "100%": { backgroundPosition: "200% 0" },
      },
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.7) 50%, transparent 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer2 1.8s infinite",
        borderRadius: "20px",
      },
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
      <Box sx={{ width: "28%", height: 20, backgroundColor: "rgba(30,58,110,0.1)", borderRadius: "6px" }} />
      <Box sx={{ width: "16%", height: 20, backgroundColor: "rgba(30,58,110,0.07)", borderRadius: "6px" }} />
    </Box>
    <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1.5, height: "70%" }}>
      {[65, 80, 50, 90, 70, 85, 60].map((h, i) => (
        <Box key={i} sx={{ flex: 1, height: `${h}%`, backgroundColor: "rgba(30,58,110,0.08)", borderRadius: "6px 6px 0 0" }} />
      ))}
    </Box>
  </Box>
);

// ─── Shared sub-item button styles ────────────────────────────────────────────
const subItemSx = (isActive, color) => ({
  borderRadius: "10px",
  py: 1.2,
  px: 2,
  borderLeft: "2px solid",
  borderLeftColor: isActive ? color : `${color}26`,
  transition: "all 0.2s ease",
  "&.Mui-selected": {
    backgroundColor: `${color}14`,
    "& .MuiListItemIcon-root": { color },
    "& .MuiListItemText-primary": { color, fontWeight: 600 },
  },
  "&:hover": {
    backgroundColor: `${color}08`,
    transform: "translateX(4px)",
    borderLeftColor: color,
  },
  "&.Mui-disabled": { opacity: 0.5 },
});

// ─── Navigation Drawer ────────────────────────────────────────────────────────
const NavigationDrawer = ({ open, onClose, activeTab, onTabChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [hrSubmenuOpen, setHrSubmenuOpen] = useState(true);
  const [productionSubmenuOpen, setProductionSubmenuOpen] = useState(true);

  // ── Tab groupings ──
  const isHrActive = [0, 20, 22, 23, 25, 27, 11].includes(activeTab);
  const isProdActive = [12, 21, 24, 26].includes(activeTab);

  // ── HR sub-items (flat) ──
  const hrSubItems = [
    { id: 20, label: "Employee Attendance",    icon: <AccessTimeIcon />,              description: "Daily employee attendance" },
    { id: 22, label: "OT Allocated",           icon: <AccessTimeIcon />,              description: "Allocated overtime records" },
    { id: 23, label: "OT Non Allocated",       icon: <AccessTimeIcon />,              description: "Non-allocated overtime" },
    { id: 25, label: "Attendance Admin",        icon: <AccessTimeIcon />,              description: "Admin attendance tools" },
    { id: 27, label: "Designation Attendance", icon: <AccessTimeIcon />,              description: "Designation wise attendance" },
    { id: 11, label: "Employees Deatils",      icon: <BadgeIcon />,                   description: "Employee records & profiles" },
  ];

  // ── Production sub-items (flat) ──
  const productionSubItems = [
    { id: 12, label: "Production Performance", icon: <PrecisionManufacturingIcon />,  description: "Current production data" },
    { id: 21, label: "Employee Allocation",    icon: <BadgeIcon />,                   description: "Shift & location allocation" },
    { id: 24, label: "Allocation Discrepancy", icon: <PrecisionManufacturingIcon />,  description: "Allocation mismatches" },
    { id: 26, label: "EWO Discrepancy",        icon: <PrecisionManufacturingIcon />,  description: "EWO mismatch reports" },
  ];

  // ── Other KPIs (coming soon) ──
  const otherKpisItems = [
    { id: 1,  label: "Financial Dashboard", icon: <AccountBalanceIcon />, color: "#10b981", description: "Budget tracking and fiscal overview", disabled: true },
    { id: 2,  label: "Sales Performance",   icon: <TrendingUp />,         color: "#f59e0b", description: "Sales metrics and targets",          disabled: true },
    { id: 3,  label: "Customer Support",    icon: <Users />,              color: "#8b5cf6", description: "Support ticket analytics",           disabled: true },
  ];

  const handleTabClick = (tabId) => {
    onTabChange(tabId);
    onClose();
  };

  // ── Reusable sub-item list renderer ──
  const renderSubItems = (items, color) => (
    <List sx={{ p: 0, pl: 2 }}>
      {items.map((item) => (
        <ListItem key={item.id} disablePadding sx={{ mb: 0.5 }}>
          <ListItemButton
            onClick={() => handleTabClick(item.id)}
            selected={activeTab === item.id}
            sx={subItemSx(activeTab === item.id, color)}
          >
            <ListItemIcon
              sx={{
                minWidth: 36,
                color: activeTab === item.id ? color : "#94a3b8",
                "& svg": { fontSize: 18 },
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              secondary={item.description}
              primaryTypographyProps={{
                fontSize: "0.85rem",
                fontWeight: activeTab === item.id ? 600 : 500,
              }}
              secondaryTypographyProps={{
                fontSize: "0.7rem",
                sx: { color: "text.secondary" },
              }}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );

  // ── Reusable coming-soon items ──
  const renderComingSoon = (items) => (
    <List sx={{ p: 0 }}>
      {items.map((item) => (
        <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
          <ListItemButton
            disabled={item.disabled}
            sx={{
              borderRadius: "12px",
              py: 1.5,
              px: 2,
              transition: "all 0.2s ease",
              "&.Mui-disabled": { opacity: 0.5, cursor: "not-allowed" },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40, color: item.color }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              secondary={item.description}
              primaryTypographyProps={{ fontSize: "0.95rem", fontWeight: 500 }}
              secondaryTypographyProps={{ fontSize: "0.75rem", sx: { color: "text.secondary", mt: 0.5 } }}
            />
            <Typography
              variant="caption"
              sx={{
                bgcolor: "rgba(0,0,0,0.04)",
                px: 1, py: 0.5,
                borderRadius: "4px",
                color: "text.secondary",
                fontSize: "0.7rem",
              }}
            >
              Coming Soon
            </Typography>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );

  // ── Top-level expandable button ──
  const TopLevelItem = ({ tabId, isActive, color, Icon, label, secondary, open, onToggle }) => (
    <ListItem
      disablePadding
      sx={{ mb: 0.5, position: "relative" }}
      secondaryAction={
        <IconButton
          edge="end"
          onClick={(e) => { e.stopPropagation(); onToggle(); }}
          sx={{ mr: 0.5, color: "#64748b", "&:hover": { backgroundColor: `${color}14` } }}
        >
          {open ? <ExpandLessIcon sx={{ fontSize: 20 }} /> : <ExpandMoreIcon sx={{ fontSize: 20 }} />}
        </IconButton>
      }
    >
      <ListItemButton
        onClick={() => handleTabClick(tabId)}
        selected={isActive}
        sx={{
          borderRadius: "12px",
          py: 1.5,
          pr: 7,
          px: 2,
          transition: "all 0.2s ease",
          "&.Mui-selected": {
            backgroundColor: `${color}14`,
            "& .MuiListItemIcon-root": { color },
            "& .MuiListItemText-primary": { color, fontWeight: 600 },
          },
          "&:hover": { backgroundColor: `${color}08`, transform: "translateX(4px)" },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: isActive ? color : "#64748b" }}>
          <Icon />
        </ListItemIcon>
        <ListItemText
          primary={label}
          secondary={secondary}
          primaryTypographyProps={{ fontSize: "0.95rem", fontWeight: isActive ? 600 : 500 }}
          secondaryTypographyProps={{ fontSize: "0.75rem", sx: { color: "text.secondary", mt: 0.5 } }}
        />
      </ListItemButton>
    </ListItem>
  );

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile ? "85%" : 320,
          maxWidth: 320,
          borderTopRightRadius: 20,
          borderBottomRightRadius: 20,
          background: "linear-gradient(135deg, #ffffff 0%, #fafcff 100%)",
          boxShadow: "8px 0 32px rgba(30,58,110,0.12)",
        },
      }}
    >
      <Box sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 32, height: 32,
                borderRadius: "10px",
                background: "linear-gradient(135deg, #330066 0%, #4A6FA5 100%)",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              <DashboardIcon sx={{ color: "white", fontSize: 18 }} />
            </Box>
            <Typography
              sx={{
                fontSize: "1.2rem",
                fontWeight: 700,
                background: "linear-gradient(135deg, #330066 0%, #4A6FA5 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Dashboards
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2, borderColor: "rgba(30,58,110,0.08)" }} />

        {/* Overview */}
        <Typography variant="subtitle2" sx={{ px: 2, mb: 1, color: "#ef4444", fontWeight: 700, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
          OVERVIEW
        </Typography>
        <List sx={{ p: 0, mb: 1 }}>
          <ListItem disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              disabled
              sx={{
                borderRadius: "12px", py: 1.5, px: 2,
                borderLeft: "4px solid #ef4444",
                backgroundColor: "rgba(239,68,68,0.04)",
                "&.Mui-disabled": { opacity: 0.5 },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: "#ef4444" }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary="Company"
                primaryTypographyProps={{ fontSize: "0.95rem", fontWeight: 700, color: "#ef4444" }}
              />
              <Typography variant="caption" sx={{ bgcolor: "rgba(0,0,0,0.04)", px: 1, py: 0.5, borderRadius: "4px", color: "text.secondary", fontSize: "0.7rem" }}>
                Coming Soon
              </Typography>
            </ListItemButton>
          </ListItem>
        </List>

        <Divider sx={{ mb: 2, borderColor: "rgba(30,58,110,0.08)" }} />

        {/* KPI's */}
        <Typography variant="subtitle2" sx={{ px: 2, mb: 1, color: "#330066", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
          KPI'S
        </Typography>

        {/* ── HR Dashboard ── */}
        <List sx={{ p: 0 }}>
          <TopLevelItem
            tabId={0}
            isActive={isHrActive}
            color="#330066"
            Icon={PeopleAltIcon}
            label="HR Dashboard"
            secondary="Attendance & employee metrics"
            open={hrSubmenuOpen}
            onToggle={() => setHrSubmenuOpen((p) => !p)}
          />
          <Collapse in={hrSubmenuOpen} timeout="auto" unmountOnExit>
            {renderSubItems(hrSubItems, "#330066")}
          </Collapse>
        </List>

        {/* ── Production Dashboard ── */}
        <List sx={{ p: 0, mt: 0.5 }}>
          <TopLevelItem
            tabId={12}
            isActive={isProdActive}
            color="#0891b2"
            Icon={PrecisionManufacturingIcon}
            label="Production Dashboard"
            secondary="Production & allocation"
            open={productionSubmenuOpen}
            onToggle={() => setProductionSubmenuOpen((p) => !p)}
          />
          <Collapse in={productionSubmenuOpen} timeout="auto" unmountOnExit>
            {renderSubItems(productionSubItems, "#0891b2")}
          </Collapse>
        </List>

        <Divider sx={{ my: 2, borderColor: "rgba(30,58,110,0.12)", borderBottomWidth: 2 }} />

        {/* Other KPIs */}
        <Typography variant="subtitle2" sx={{ px: 2, mb: 1, color: "#f43f5e", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
          OTHER KPIs
        </Typography>
        {renderComingSoon(otherKpisItems)}
      </Box>
    </Drawer>
  );
};

// ─── Main Dashboard ───────────────────────────────────────────────────────────
const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    divisionData,
    traineeTypes,
    traineeDivision,
    allAttendance,
    loading,
    weeklyAttendance,
  } = useSelector((state) => state.attendanceCard);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [cachedAllAttendance, setCachedAllAttendance] = useState(null);
  const [cachedTraineeTypes, setCachedTraineeTypes] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [loadingStates, setLoadingStates] = useState({
    divisionData: true,
    traineeTypes: true,
    traineeDivision: true,
    allAttendance: true,
    weeklyAttendance: true,
  });

  const today = new Date().toISOString().split("T")[0];

  // ── Tab groupings ──
  const isHrSubTab    = [20, 22, 23, 25, 27, 11].includes(activeTab);
  const isProdSubTab  = [21, 24, 26].includes(activeTab);           // 12 renders <Production /> directly
  const isHrView      = activeTab === 0 || isHrSubTab;
  const isProdView    = activeTab === 12 || isProdSubTab;

  const handleTabChange = (tabId) => setActiveTab(tabId);
  const toggleDrawer    = () => setDrawerOpen((p) => !p);

  // ── Cache hydration ──
  useEffect(() => {
    const cachedTrainee = localStorage.getItem("dashboard_traineeTypes");
    if (cachedTrainee) {
      setCachedTraineeTypes(JSON.parse(cachedTrainee));
      setLoadingStates((prev) => ({ ...prev, traineeTypes: false }));
    }
    setDataLoaded(true);
  }, []);

  // ── Loading state watchers ──
  useEffect(() => {
    if (divisionData?.length > 0)
      setLoadingStates((prev) => ({ ...prev, divisionData: false }));
  }, [divisionData]);

  useEffect(() => {
    if (traineeTypes?.length > 0) {
      setLoadingStates((prev) => ({ ...prev, traineeTypes: false }));
      localStorage.setItem("dashboard_traineeTypes", JSON.stringify(traineeTypes));
    }
  }, [traineeTypes]);

  useEffect(() => {
    if (traineeDivision?.length > 0)
      setLoadingStates((prev) => ({ ...prev, traineeDivision: false }));
  }, [traineeDivision]);

  useEffect(() => {
    if (allAttendance?.length > 0) {
      setLoadingStates((prev) => ({ ...prev, allAttendance: false }));
      localStorage.setItem("dashboard_allAttendance", JSON.stringify(allAttendance));
    }
  }, [allAttendance]);

  useEffect(() => {
    if (weeklyAttendance?.length > 0)
      setLoadingStates((prev) => ({ ...prev, weeklyAttendance: false }));
  }, [weeklyAttendance]);

  // ── Data fetch ──
  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) metaThemeColor.setAttribute("content", "#330066");

    const fetchData = async () => {
      try {
        if (!cachedAllAttendance) dispatch(GetAllAttendance(today, today));
      } catch (error) {
        console.error("Error dispatching actions:", error);
      }
    };
    fetchData();
  }, [dispatch, cachedAllAttendance, cachedTraineeTypes, today]);

  // ── Header title ──
  const pageTitle =
    isProdView      ? "Production Dashboard" :
    isHrView        ? "HR Dashboard"         :
    activeTab === 1 ? "Financial Dashboard"  :
    activeTab === 4 ? "Company Overview"     :
                      "Dashboard";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 120px)",
        backgroundColor: "#F4F6FA",
        padding: { xs: "20px 14px", sm: "28px 20px", md: "36px 28px" },
        backgroundImage: "radial-gradient(rgba(30,58,110,0.06) 1px, transparent 1px)",
        backgroundSize: "28px 28px",
        overflow: "hidden",
      }}
    >
      {/* ── Header ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton
            onClick={toggleDrawer}
            sx={{
              backgroundColor: "#ffffff",
              boxShadow: "0 2px 8px rgba(30,58,110,0.12)",
              borderRadius: "12px",
              padding: "10px",
              "&:hover": { backgroundColor: "#f5f5f5", transform: "scale(1.05)" },
              transition: "all 0.2s ease",
            }}
          >
            <MenuIcon sx={{ color: "#330066" }} />
          </IconButton>

          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              background: "linear-gradient(135deg, #330066 0%, #4A6FA5 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.2rem", sm: "1.5rem" },
            }}
          >
            {pageTitle}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{
            color: "#64748b",
            backgroundColor: "#ffffff",
            padding: "6px 12px",
            borderRadius: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            display: { xs: "none", sm: "block" },
          }}
        >
          {new Date().toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </Typography>
      </Box>

      {/* ── Navigation Drawer ── */}
      <NavigationDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {/* ── Scrollable Content Area ── */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          pr: { xs: 0, sm: 1 },
          "&::-webkit-scrollbar": { width: "0px" },
          "&::-webkit-scrollbar-track": { background: "#f1f1f1", borderRadius: "10px" },
          "&::-webkit-scrollbar-thumb": {
            background: "#F4F6FA",
            borderRadius: "10px",
            "&:hover": { background: "#a8a8a8" },
          },
        }}
      >
        {/* ══════════════════════════════════════
            HR Dashboard — main overview (tab 0)
        ══════════════════════════════════════ */}
        {activeTab === 0 && (
          <Fade in={true} timeout={600}>
            <Box>
              <Box sx={{ marginBottom: "24px" }}>
                {loadingStates.allAttendance ? (
                  <ChartSkeleton height={350} />
                ) : (
                  <EmployeeStrengthAttendanceChart
                    allAttendance={cachedAllAttendance || allAttendance}
                  />
                )}
              </Box>

              {/* <Box sx={{ marginBottom: "24px" }}>
                <EmployeeAttendanceChart />
              </Box> */}

              <Box sx={{ marginBottom: "24px" }}>
                <DGESatt data={[]} loading={false} />
              </Box>

              <Box sx={{ height: "20px" }} />
            </Box>
          </Fade>
        )}

        {/* ══════════════════════════════════════
            HR sub-tabs  (20, 22, 23, 25, 27, 11)
        ══════════════════════════════════════ */}
        {isHrSubTab && (
          <Fade in={true} timeout={600}>
            <Box>
              {activeTab === 11 ? (
                <Employees />
              ) : (
                <AttendanceManagement activeSubTab={activeTab} />
              )}
            </Box>
          </Fade>
        )}

        {/* ══════════════════════════════════════
            Production Dashboard — main (tab 12)
        ══════════════════════════════════════ */}
        {activeTab === 12 && (
          <Fade in={true} timeout={600}>
            <Box>
              <Production />
            </Box>
          </Fade>
        )}

        {/* ══════════════════════════════════════
            Production sub-tabs  (21, 24, 26)
        ══════════════════════════════════════ */}
        {isProdSubTab && (
          <Fade in={true} timeout={600}>
            <Box>
              <AttendanceManagement activeSubTab={activeTab} />
            </Box>
          </Fade>
        )}

        {/* ══════════════════════════════════════
            Company Overview (tab 4)
        ══════════════════════════════════════ */}
        {activeTab === 4 && (
          <Fade in={true} timeout={600}>
            <Box>
              <CompanyDashboard selectedYear="2026" />
            </Box>
          </Fade>
        )}

        {/* ══════════════════════════════════════
            Financial Dashboard (tab 1 — coming soon)
        ══════════════════════════════════════ */}
        {activeTab === 1 && (
          <Fade in={true} timeout={500}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                color: "white",
                padding: "40px 36px",
                borderRadius: "20px",
                marginBottom: "32px",
                boxShadow: "0 8px 40px rgba(16,185,129,0.25)",
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: "8px", fontSize: "28px" }}>
                Financial Dashboard
              </Typography>
              <Typography sx={{ fontSize: "16px", opacity: 0.85, fontWeight: 400 }}>
                Financial metrics, budgets, and fiscal performance overview.
              </Typography>
              <Box sx={{ marginTop: "24px" }}>
                <Typography sx={{ fontSize: "14px", opacity: 0.75, fontStyle: "italic" }}>
                  Financial dashboard content coming soon...
                </Typography>
              </Box>
            </Box>
          </Fade>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;